// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Cyprus from '../_raw/flag/icon_flag_cyprus.png';

export default () => <img src={Cyprus} alt="Cyprus" />;
